import request from '@/utils/request'

export function apiGetExhibitionList(params) {
  return request({
    url: '/exhibition/list',
    method: 'get',
    params
  })
}

export function apiGetExhibitionDtl(params) {
  return request({
    url: '/exhibition/detail',
    method: 'get',
    params
  })
}

export function apiGetExhibitionInfo(params) {
  return request({
    url: '/exhibition/info',
    method: 'get',
    params
  })
}

export function apiGetExhibitionBoothCheck(params) {
  return request({
    url: '/exhibitionBooth/check',
    method: 'get',
    params
  })
}

export function apiBindExhibitionBooth(data) {
  return request({
    url: '/exhibitionBooth/bind',
    method: 'post',
    data
  })
}

export function apiGetExhibitionImageInfo(params) {
  return request({
    url: '/exhibitionImage/info',
    method: 'get',
    params
  })
}

export function apiGetExhibitionBoothBindList(params) {
  return request({
    url: '/exhibitionBooth/bindList',
    method: 'get',
    params
  })
}

export function apiGetUploadSignUrl(params) {
  return request({
    url: '/upload/signUrl',
    method: 'get',
    params
  })
}

export function apiAddUserExhibition(data) {
  return request({
    url: '/userExhibition/add',
    method: 'post',
    data
  })
}

export function apiGetUserExhibitionList(params) {
  return request({
    url: '/userExhibition/list',
    method: 'get',
    params
  })
}

export function apiGetUserExhibitionInfo(params) {
  return request({
    url: '/userExhibition/info',
    method: 'get',
    params
  })
}

export function apiExhibitionCancel(data) {
  return request({
    url: '/userExhibition/cancel',
    method: 'post',
    data
  })
}

export function apiGetUserExhibitionlogList(params) {
  return request({
    url: '/userExhibition/logList',
    method: 'get',
    params
  })
}

export function apiGetBoothGoods(params) {
  return request({
    url: '/goods/booth',
    method: 'get',
    params
  })
}

export function apiAddUserInvoice(data) {
  return request({
    url: '/userInvoice/refundAdd',
    method: 'post',
    data
  })
}

export function apiGetUserInvoiceList(params) {
  return request({
    url: '/userInvoice/refundList',
    method: 'get',
    params
  })
}
export function apiUpdateUserInvoice(data) {
  return request({
    url: '/userInvoice/refundUpdate',
    method: 'post',
    data
  })
}
export function apiGetConfigInfo(params) {
  return request({
    url: '/config/info',
    method: 'get',
    params
  })
}
